<div class="flex h-full min-h-0 w-full flex-col items-stretch justify-start space-y-4 overflow-hidden">
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
        <div>
            <p class="text-transparent">LHS</p>
        </div>


        <div class="">
            <div class="grid grid-cols-1 sm:hidden">
                <select aria-label="Select a tab" [value]="selectedTab()" (change)="selectTabMobile($event)"
                    class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white/5 py-2 pl-3 pr-8 text-base text-gray-100 outline-1 -outline-offset-1 outline-white/10 *:bg-gray-800 focus:outline-2 focus:-outline-offset-2 focus:outline-primary">
                    @for (tab of tabs; track tab.id) {
                    @if (tabVisible(tab)) {
                    <option [value]="tab.id">{{ tab.mobileLabel }}</option>
                    }
                    }
                </select>
                <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                    class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-400">
                    <path
                        d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </div>
            <div class="hidden sm:block">
                <nav aria-label="Tabs" class="flex space-x-4">
                    @for (tab of tabs; track tab.id) {
                    @if (tabVisible(tab)) {
                    <a [routerLink]="['/my-brand', tab.id]"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(tab.id)"
                        [attr.aria-current]="selectedTab() === tab.id ? 'page' : null">{{ tab.label }}</a>
                    }
                    }
                </nav>
            </div>
        </div>



    </div>
    <div class="flex flex-1 min-h-0 w-full flex-col items-stretch overflow-y-auto">
        @switch (selectedTab()) {
        @case ('business-info') {
        <mb-brand-account></mb-brand-account>
        }
        @case ('products') {
        <mb-brand-products></mb-brand-products>
        }
        @case ('content-library') {
        <mb-content-library></mb-content-library>
        }
        @case ('compliance') {
        <mb-compliance></mb-compliance>
        }
        @case ('team-members') {
        <mb-brand-team></mb-brand-team>
        }
        @case ('affiliate-marketing') {
        <mb-affiliate-marketing></mb-affiliate-marketing>
        }
        @case ('billing') {
        @if (canShowBillingTab()) {
        <mb-brand-billing></mb-brand-billing>
        }
        }
        @case ('social-ads') {
        <!-- <mb-social-ads [businessAccountId]="currentUserService.focussedBrand?.id"></mb-social-ads> -->
        <mb-brand-tiktok-connect [businessAccountId]="currentUserService.focussedBrand?.id"></mb-brand-tiktok-connect>
        }
        }
    </div>
</div>
